<div class="containerStepper">
  <mat-vertical-stepper
    [linear]="true"
    orientation="vertical"
    #stepper
    (selectionChange)="this.stepperSelectionChange(stepper, $event)"
    >
    <mat-step label="Willkommen" [editable]="this.processState !== ProcessState.Importing">
      <div style="display: flex">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 600px">
          <div>
            <h1>{{ this.importConfig?.welcomePage.title }}</h1>
          </div>
        </div>
      </div>
      <div fxLayout="row">
        <div fxLayoutAlign="center center">
          <p>
            {{ this.importConfig?.welcomePage.description }}
          </p>
        </div>
      </div>
      <hr />
      <div fxLayout="row" style="float: right">
        <div fxFlex="30">
          <button mat-button matStepperNext>Weiter</button>
        </div>
      </div>
    </mat-step>

    @for (page of this.importConfig?.contentPages; track page) {
      <mat-step
        [completed]="false"
        [editable]="this.processState !== ProcessState.Importing"
        label="{{ page.title }}"
        >
        <div fxLayout="row">
          <div fxLayoutAlign="center center">
            <p>
              {{ page.description }}
            </p>
          </div>
        </div>
        <content-page-wrapper
          [component]="page.component"
          [transferObject]="this.importConfig?.transferObject"
          (componentInstantiated)="page.componentInstance = $event"
        ></content-page-wrapper>
        <hr />
        <div fxLayout="row" style="float: right">
          <div fxFlex="30">
            <button mat-button matStepperPrevious>Zurück</button>
            <button mat-button (click)="moveStep(stepper, page.componentInstance)">Weiter</button>
          </div>
        </div>
      </mat-step>
    }

    <mat-step label="Import">
      @if (this.processState === ProcessState.BeforeFinishClick) {
        <div>
          <div fxLayout="row">
            <div fxLayoutAlign="center center">
              <p>
                Alle benötigten Informationen wurden zusammengestellt. Klicken Sie auf Fertigstellen, um den Vorgang zu
                starten.
              </p>
            </div>
          </div>
          <div fxLayout="row" style="float: right">
            <div fxFlex="30">
              <button mat-button matStepperPrevious>Zurück</button>
              <button mat-button (click)="this.finishClick()">Fertigstellen</button>
            </div>
          </div>
        </div>
      } @else {
        <div fxLayout="row">
          <div fxLayoutAlign="center center">
            <dx-progress-bar
              class="dx-field-label"
              [width]="'100%'"
              [min]="0"
              [max]="1"
              [value]="this.progressPercentage"
              [statusFormat]="this.progressStatusFormat"
            ></dx-progress-bar>
          </div>
        </div>
        <div fxLayout="row" style="float: right">
          <div fxFlex="30">
            <button mat-button [disabled]="this.processState === ProcessState.Importing" (click)="stepper.previous()">
              Zurück
            </button>
            <button [id]="'retryButton'" mat-button width="200px" (click)="this.retryButtonClick()">
              {{ this.retryButtonCaption }}
            </button>
          </div>
        </div>
      }
    </mat-step>
  </mat-vertical-stepper>
</div>

